import * as THREE from 'three';

export const createMaterials = () => {
    return {
        solidBlue: new THREE.MeshStandardMaterial({ color: 0x007bff, metalness: 0.7, roughness: 0.3 }),
        wireframeCyan: new THREE.MeshBasicMaterial({ color: 0x00ffff, wireframe: true }),
        solidGreenPCB: new THREE.MeshStandardMaterial({ color: 0x008000, metalness: 0.2, roughness: 0.6 }),
        solidSilver: new THREE.MeshStandardMaterial({ color: 0xc0c0c0, metalness: 0.8, roughness: 0.1 }),
        solidBlack: new THREE.MeshStandardMaterial({ color: 0x202020, metalness: 0.1, roughness: 0.9 }),
        robotRed: new THREE.MeshStandardMaterial({ color: 0xcc0000, metalness: 0.7, roughness: 0.3 }),
        droneYellow: new THREE.MeshStandardMaterial({ color: 0xffff00, metalness: 0.7, roughness: 0.3 }),
        frameGray: new THREE.MeshStandardMaterial({ color: 0x808080, metalness: 0.5, roughness: 0.5 }),
        partOrange: new THREE.MeshStandardMaterial({ color: 0xffa500, metalness: 0.6, roughness: 0.4 }),
    };
}; 